import React from 'react';
import PropTypes from 'prop-types';

import ItemVariation from '../../../organisms/FoodMenu/components/variants/item/ItemVariation';

const SpecialPriceVariation = ({ variations, precision }) => {
  const variationsStyle = {
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
  };

  return (
    <div style={variationsStyle}>
      {variations.map(({ name, price }, index) => (
        <ItemVariation
          key={name}
          name={name}
          price={price}
          precision={precision}
          isOnlyVariation={variations.length === 1}
          isLastVariation={index === variations.length - 1}
        />
      ))}
    </div>
  );
};

SpecialPriceVariation.propTypes = {
  variations: PropTypes.array.isRequired,
};

export default SpecialPriceVariation;
